<template>
	<div>
		<div v-if="!pageNotConfirm">
			<a-page-header title="Instance Managers">
				<template slot="extra">
					<a-button key="1" type="primary" @click="showAddModal()">Add New Instance Manager</a-button>
				</template>
			</a-page-header>
			<data-table ref="instanceManagersDataTable"
									:columns="columns"
									:data-source="instanceManagerState.instantManagers"
									:loading="loading"
									@refreshData="fetchInstanceManagers"
									:totalCount="instanceManagerState.instanceManagersCount"
									rowKey="id">
				<span slot="action" slot-scope="record">
					<a-tooltip title="Edit">
						<a class="edit-icon" @click="showEditModal(record.id)">
							<a-icon type="edit" />
						</a>
					</a-tooltip>
					<a-divider type="vertical" />
					<a-tooltip title="Delete">
						<a class="trash-icon" @click="confirmDelete(record.id)">
							<a-icon type="delete" />
						</a>
					</a-tooltip>
				</span>
			</data-table>
			<InstanceManagerModal v-model="isInstanceManagerModalVisible"
														:businesses="businessState.businesses"
														:instance="instanceManager"
														:title="modalTitle"
														:mode="mode"></InstanceManagerModal>
		</div>
		<TempPassConfirm v-model="pageNotConfirm" @confirm="checkTempPass"></TempPassConfirm>
	</div>
</template>
<script>
	import {
		instanceManagerState,
		instanceManagerMutations,
		businessState,
		businessMutations,
	} from "../../Store/store.js";
	import InstanceManagerModal from "./InstanceManagerModal.vue";
	import TempPassConfirm from "../Share/TempPassConfirm.vue"

	const columns = [
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			sorter: true,
			ellipsis: true,
		},
		{
			title: "Limit",
			dataIndex: "limit",
			key: "limit",
			sorter: true,
			ellipsis: true,
		},
		{
			title: "Counter",
			dataIndex: "counter",
			key: "counter",
			sorter: true,
			ellipsis: true,
		},
		{
			title: "Actions",
			key: "action",
			scopedSlots: { customRender: "action" },
			ellipsis: true,
			width: 70,
		},
	];

	export default {
		async mounted() {
			await this.fetchInstanceManagers();
			await this.fetchBusinesses();
		},
		data() {
			return {
				instanceManagerState,
				instanceManagerMutations,
				businessState,
				businessMutations,
				columns: columns,
				isSaving: false,
				loading: false,
				isInstanceManagerModalVisible: false,
				instanceManager: {},
				mode: "Add",
				modalTitle: "",
				pageNotConfirm: true
			};
		},
		methods: {
			async fetchInstanceManagers(params) {
				await this.instanceManagerMutations.setInstanceManager(params);
			},
			async fetchBusinesses() {
				await businessMutations.setBusinesses();
			},
			showAddModal() {
				this.mode = "Add";
				this.instanceManager = {};
				this.modalTitle = `${this.mode} Instance Manager`;
				this.isInstanceManagerModalVisible = true;
			},
			showEditModal(recordId) {
				this.mode = "Update";
				this.instanceManager = {
					...this.instanceManagerState.instantManagers.find(
						(i) => i.id == recordId
					),
				};
				this.modalTitle = `${this.mode} instance Manager`;
				this.isInstanceManagerModalVisible = true;
			},
			confirmDelete(instanceManagerId) {
				let self = this;
				this.$confirm({
					title: "Delete Instance Manger",
					content: "Are you sure you want to delete this instance manager?",
					okText: "Delete",
					okType: "danger",
					cancelText: "Cancel",
					onOk() {
						self.deleteInstanceManager(instanceManagerId);
					},
					onCancel() { },
				});
			},
			checkTempPass(value) {
				this.pageNotConfirm = value;
			},
			async deleteInstanceManager(instanceManagerId) {
				try {
					let deleteResponse =
						await this.instanceManagerMutations.deleteInstanceManager(
							instanceManagerId
						);
					if (deleteResponse?.status == 200) {
						this.$message.success("Instance Manager deleted successfully!");
					}
				} catch (error) {
					this.showError(error);
				} finally {
					this.$refs.instanceManagersDataTable.refreshData(true);
				}
			},
		},
		components: {
			InstanceManagerModal,
			TempPassConfirm
		},
	};
</script>
